import { createAction } from 'redux-actions'

import { googleIdentify } from './googleAnalytics'

export const sendError = createAction('ANALYTICS/SEND_ERROR')

export const track = createAction('ANALYTICS/TRACK', (category, action, data) => ({ category, action, data }))

export const register = createAction('ANALYTICS/REGISTER', (id, first_login) => {
  googleIdentify(id)
  return { id, first_login }
})

export const showError = createAction('ANALYTICS/SHOW_ERROR')
